<script>
  import { page } from '@inertiajs/svelte';
  import { fade } from 'svelte/transition';
  import responsive from '@/js/utils/responsive';

  import ProtoMobile from './proto/Mobile.svelte';
  import ProtoLaptop from './proto/Laptop.svelte';
  import ProtoScroll from './proto/Scroll.svelte';
  import ProtoMobileControls from './proto/ScrollMobileControls.svelte';

  export let item;
  function handleScrollUp() {
    imagePos += 100;
  }

  function handleScrollDown() {
    imagePos -= 100;
  }

  let imagePos = 0;
  let loading = true;
  let innerWidth = 0;
  $: mobile = innerWidth <= responsive.s;
</script>

<svelte:window bind:innerWidth />

<div
  class="pg-item"
  class:has-mobile={item.mobile}
  class:has-laptop={item.laptop}
>
  {#if item.mobile}
    <div class="proto-item proto-item--mobile">
      <div class="proto-item__screen">
        <ProtoScroll image={item.mobile} {loading} bind:imagePos />
      </div>
      <ProtoMobile />
      {#if mobile}
        <ProtoMobileControls
          on:clickUp={handleScrollUp}
          on:clickDown={handleScrollDown}
        />
      {/if}
    </div>
  {/if}

  {#if item.laptop}
    <div class="proto-item proto-item--laptop">
      <div class="proto-item__screen">
        <ProtoScroll image={item.laptop} {loading} />
      </div>
      <ProtoLaptop />
    </div>
  {/if}
</div>

<style lang="scss">
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .pg-item {
    display: flex;
    gap: 4rem;

    &.has-mobile.has-laptop {
      .proto-item--laptop {
        @include resp-max('s') {
          display: none;
        }
      }
    }
  }

  .proto-item {
    position: relative;
    margin: 0 auto;

    &--mobile {
      width: 230px;
      aspect-ratio: 20/41;
    }
    &--laptop {
      width: 820px;
      aspect-ratio: 70/41;
    }

    &__screen {
      position: absolute;
      inset: 0;

      .proto-item--mobile & {
        padding: 17% 5% 17% 5.5%;
      }
      .proto-item--laptop & {
        padding: 2.4% 10.1% 8.5% 9.9%;
      }

      :global {
        svg {
          width: 100%;
        }
      }
    }
  }

  .hero-loader {
    position: absolute;
    z-index: 10;
    inset: 0;

    background: rgb(var(--white));

    display: flex;
    align-items: center;
    justify-content: center;

    &__spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      margin: {
        top: -3.75rem;
        left: -3.75rem;
      }

      display: block;
      width: 7.5rem;
      height: 7.5rem;
      border-radius: 50%;

      mask-size: contain;

      background: conic-gradient(
        from 0.25turn at 50%,
        var(--aqua-2),
        rgb(var(--white))
      );

      animation: spin 3s infinite linear;
    }

    &__logo {
      width: 3rem;
    }
  }
</style>
